export default __webpack_public_path__ + "static/media/swiftstrikes5.a5df83a4.png";